import { Injectable } from '@angular/core';
import { ActivityLocation, IActivityLocation, ILatLon } from '@curbnturf/entities';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as ActivityActions from './activity.actions';
import { ActivityState } from './activity.reducer';
import { activityQuery } from './activity.selectors';

@Injectable({
  providedIn: 'root',
})
export class ActivityLocationFacade {
  activityEntities$: Observable<{ [id: number]: IActivityLocation }>;
  activities$: Observable<IActivityLocation[]>;
  currentUserActivities$: Observable<IActivityLocation[]>;
  awaitedActivity$: Observable<IActivityLocation | undefined>;
  pendingImage$: Observable<FormData | undefined>;
  selected$: Observable<ActivityLocation | undefined>;
  error$: Observable<string | undefined>;

  constructor(private store: Store<ActivityState>) {
    this.activityEntities$ = this.store.pipe(select(activityQuery.getActivityEntities));
    this.activities$ = this.store.pipe(select(activityQuery.getActivities));
    this.currentUserActivities$ = this.store.pipe(select(activityQuery.getCurrentUserActivities));
    this.awaitedActivity$ = this.store.pipe(select(activityQuery.getAwaitedActivity));
    this.pendingImage$ = this.store.pipe(select(activityQuery.getPendingImage));
    this.selected$ = this.store.pipe(select(activityQuery.getSelectedActivity));
    this.error$ = this.store.pipe(select(activityQuery.getError));
  }

  awaitActivity(activity?: IActivityLocation) {
    this.store.dispatch(ActivityActions.awaitActivity({ activity }));
  }

  cancelAwait() {
    this.store.dispatch(ActivityActions.cancelAwait());
  }

  create(activity?: IActivityLocation) {
    this.store.dispatch(ActivityActions.createActivity({ activity }));
  }

  remove(id: number) {
    this.store.dispatch(ActivityActions.removeActivity({ activityId: id }));
  }

  update(activity: IActivityLocation) {
    this.store.dispatch(ActivityActions.updateActivity({ activity }));
  }

  removePhoto(activityId: number, index: number): void {
    this.store.dispatch(ActivityActions.removeImageFromActivity({ activityId, index }));
  }

  cancelPoiImageUpload(): void {
    this.store.dispatch(ActivityActions.cancelUploadActivityImage());
  }

  hide(activity: IActivityLocation) {
    this.store.dispatch(ActivityActions.hideActivity({ activity }));
  }

  show(activity: IActivityLocation) {
    this.store.dispatch(ActivityActions.showActivity({ activity }));
  }

  load(id: number) {
    this.store.dispatch(ActivityActions.loadActivity({ activityId: id }));
  }

  loaded(activity: IActivityLocation) {
    this.store.dispatch(ActivityActions.activityLoaded({ activity }));
  }

  loadForUser() {
    this.store.dispatch(ActivityActions.loadActivities({}));
  }

  // this is for loading activities around a specific point for Listings and Boondocks
  loadByCoordinates(coordinates: ILatLon) {
    this.store.dispatch(ActivityActions.loadActivities({ ...coordinates, hidden: false, available: true, distance: 20 }));
  }

  clear() {
    this.store.dispatch(ActivityActions.clearActivities());
  }

  favorite(activity: IActivityLocation) {
    this.store.dispatch(ActivityActions.favoriteActivity({ activity }));
  }

  unfavorite(activity: IActivityLocation) {
    this.store.dispatch(ActivityActions.unfavoriteActivity({ activity }));
  }
}
